<template>
  <v-card outlined>
    <v-card-title v-if="showTitle"> Templates </v-card-title>
    <v-data-table
      v-model="selected"
      :items="list"
      :headers="headers"
      :loading="loading"
      disable-sort
      :search="filter.search"
      :footer-props="{
        'items-per-page-options': [100, 250, 500, 1000]
      }"
      mobile-breakpoint="0"
      class="row-pointer"
      show-select
      item-key="id"
      :server-items-length="total_templates"
      :options.sync="options"
      @click:row="editTemplate"
    >
      <template #[`header.published`]="{}">
        <v-icon small> wifi </v-icon>
      </template>

      <template #[`item.published`]="{ item }">
        <v-icon
          small
          :color="item.published ? 'success' : 'error'"
        >
          wifi
        </v-icon>
      </template>
      <template #[`item.imageFlatSide1Thumb`]="{ item }">
        <v-img
          v-if="item.imageFlatSide1Thumb"
          :src="item.imageFlatSide1Thumb"
          width="100"
          contain
          class="my-1"
        />
      </template>
      <template #[`item.mfgTypeId`]="{ item }">
        {{ mfg_type_name(item.mfgTypeId) }}
      </template>
      <template #[`item.resizedToCoreProductIds`]="{ item }">
        <div
          v-for="id in item.resizedToCoreProductIds"
          :key="id"
        >
          {{ product_name(id) }}
        </div>
      </template>
      <template #[`item.modifiedDate`]="{ item }">
        {{ item.modifiedDate | normalDateWithTime }}
      </template>
      <template #[`item.actions`]="{}">
        <v-icon>more_vert</v-icon>
      </template>
    </v-data-table>
    <TemplatesEdit @reload="loadData" />
  </v-card>
</template>

<script>
import TemplatesEdit from '@/components/templates/Edit';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogTemplates',
  components: { TemplatesEdit },
  props: { showTitle: { type: Boolean, default: false } },
  data: () => {
    return {
      headers: [
        { value: 'published' },
        { value: 'imageFlatSide1Thumb' },
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        {
          text: 'Modified',
          value: 'modifiedDate'
        },
        { text: 'Mfg', value: 'mfgTypeId' },
        {
          text: 'Resized To',
          value: 'resizedToCoreProductIds',
          sortable: false
        },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false,
      options: {}
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    selected: {
      get() {
        return this.$store.getters['catalog/selected'];
      },
      set(val) {
        this.$store.dispatch('catalog/setSelected', val);
      }
    },
    ...mapGetters({
      list: 'templates/list',
      product_name: 'lookup/product_name',
      mfg_type_name: 'lookup/mfg_type_name',
      total_templates: 'templates/total'
    })
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true
    },
    'filter.page'(val, oldVal) {
      if (val !== oldVal) {
        this.options.page = val;
      }
    }
  },
  mounted() {
    this.selected = [];
  },
  methods: {
    loadData() {
      this.loading = true;
      this.filter = Object.assign(this.filter, {
        itemsPerPage: this.options.itemsPerPage,
        page: this.options.page
      });
      this.$store
        .dispatch('templates/load', this.filter)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editTemplate(template) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_TEMPLATE_SHOW, {
        id: template.id
      });
    }
  }
};
</script>
